import { compat } from '@flarum/core/forum';
import BlogMeta from '../common/Models/BlogMeta';
import ArticleSubscription from './components/ArticleSubscription';
import BlogCategories from './components/BlogCategories';
import BlogAuthor from './components/BlogItemSidebar/BlogAuthor';
import BlogItemSidebar from './components/BlogItemSidebar/BlogItemSidebar';
import BlogOverviewItem from './components/BlogOverviewItem';
import BlogPostController from './components/BlogPostController';
import Composer from './components/Composer/Composer';
import ComposerPreview from './components/Composer/ComposerPreview';
import FeaturedBlogItem from './components/FeaturedBlogItem';
import ForumNav from './components/ForumNav';
import BlogPostSettingsModal from './components/Modals/BlogPostSettingsModal';
import RenameArticleModal from './components/Modals/RenameArticleModal';
import ModuleEmailModal from './components/Modals/ModuleEmailModal';
import BlogItem from './pages/BlogItem';
import BlogOverview from './pages/BlogOverview';

export default () => {
  Object.assign(compat, {
    'DeepIntegrations/blog/components/BlogItemSidebar': BlogItemSidebar,
    'DeepIntegrations/blog/components/BlogAuthor': BlogAuthor,

    'DeepIntegrations/blog/components/Composer/Composer': Composer,
    'DeepIntegrations/blog/components/Composer/ComposerPreview': ComposerPreview,

    'DeepIntegrations/blog/components/Modals/BlogPostSettingsModal': BlogPostSettingsModal,
    'DeepIntegrations/blog/components/Modals/RenameArticleModal': RenameArticleModal,
    'DeepIntegrations/blog/components/Modals/ModuleEmailModal': ModuleEmailModal,

    'DeepIntegrations/blog/components/ArticleSubscription': ArticleSubscription,
    'DeepIntegrations/blog/components/BlogCategories': BlogCategories,
    'DeepIntegrations/blog/components/BlogOverviewItem': BlogOverviewItem,
    'DeepIntegrations/blog/components/BlogPostController': BlogPostController,
    'DeepIntegrations/blog/components/FeaturedBlogItem': FeaturedBlogItem,
    'DeepIntegrations/blog/components/ForumNav': ForumNav,

    'DeepIntegrations/blog/pages/BlogItem': BlogItem,
    'DeepIntegrations/blog/pages/BlogOverview': BlogOverview,

    'DeepIntegrations/blog/models/BlogMeta': BlogMeta,
  });
};
